import { $CommonServiceFn } from "../network/Service";
export const otpMedium = {
    otpSendMedium: [{
        sms: 1
    }]
};

export const errorMsg = {
    firstName: {
        invalid: "Please enter valid First Name Allowed",
        empty: "First name is required",
    },
    lastName: {
        invalid: "Please enter valid Last Name Allowed",
        empty: "Last name is required",
    },
    phoneNumber: {
        invalid: "Enter the valid Phone Number",
        empty: "Please enter the Phone Number"
    },
    emailId: {
        invalid: "Please enter a valid email address",
        empty: "Please enter email address",
        already: "This email is already associated with other account or partner",
    },
    password: {
        invalid: "Your password does not meet our security criteria",
        empty: "Please enter password"
    },
    confirmPassword: {
        invalid: "Your password does not match",
        empty: "Please enter confirm password"
    },
    otp: {
        invalid: "Please enter a valid OTP",
        empty: "Please enter OTP"
    },
    somethingErr: "Something went wrong. Try again later."
}

export const successMsg = {
    forgotLinkSent: 'A reset password link has been sent to your registered email address. Click the link to create a new password.',
    otpSent: 'OTP has been sent to your email address and phone number.',
}

export const hideSideImageForUrlPaths = ["/account/redirect", "/account/unauthorizedaccess", "/account/activation", '/account/invalid'];

export const specialIPv4 = [
    {
        "value": "203.110.90.18",
        "label": "IndianOffice"
    },
    {
        "value": "23.25.130.161",
        "label": "AmericanOffice"
    },
    {
        "value": "223.190.87.185",
        "label": "IndiaOffice2"

    }
];
export const nonOtpId = ["8b818f5e-74df-48fa-af23-a71b9069a243","305BF342-40F2-4AE3-A8C0-4AC8C3754279","9E6EA069-3EFF-429A-8FFD-6A082F1C72B3","A4C6085F-6A0E-450C-B55F-A387F4378CE4","b1890b86-6554-47f1-97cb-8c0357449bde","1C2D6B44-6AB0-4AA0-8743-765101C829AC","EFD54843-7CC5-4B68-9A0B-CD8C8DA28733","05d9407b-40ed-487a-9bb8-cb330704812e"]
export const LeadStackerToken1 = "6606a0c3-2cbf-4a3a-b12d-484c15559f61"







export const leadPostApi = (JsonObj) => {
    return new Promise((resolve, reject) => {
        postContactLead(JsonObj).then((res) => {
            resolve(res);
        }).catch((err) => {
            resolve('err');
        });
    });

}
export const leadPostContactApi = (json, aWithDates) => {
    return new Promise((resolve, reject) => {
        postContactLeadRegist(json, aWithDates).then((res) => {

            let responseId = res?.data?.contact?.id;


            let deleteTag = res?.data?.contact?.tags.filter(itemA => {
                let partsA = itemA.replace(/\s/g, '').toLowerCase().split(',');
                let partialMatch = aWithDates.some(itemB => {
                    let partsB = itemB.replace(/\s/g, '').toLowerCase().split(',');

                    // return partsA.slice(0, -1).join(',') == partsB.slice(0, -1).join(',')
                    return partsA.join(',') == partsB.join(',')

                         });
                return partialMatch;
            });

            let json = {
                id: responseId,
                tags: aWithDates,
                deleteTagss: deleteTag,
                contact : "NEW"
            }
            resolve(json);
        }).catch((err) => {
            resolve('err');
        });
    });

}

export const leadCommonApi = async (result, method,tag,email) => {

    if (method == "POST" && result?.contact != "NEW" && result !== "err") {

        const results = await leadPostApi(result);
        return results
    } else if (method == "DELETE"  && result !== "err") {
        const results = await leadDeleteApi(result);
        return results
    }else if(method == "PUT"){
        const results = await leadPutApi(result,tag,email)
        return results
    }

}
export const leadDeleteApi = (JsonObj) => {
    return new Promise((resolve, reject) => {
        deleteContactLead(JsonObj).then((res) => {
            resolve(res);
        }).catch((err) => {
            resolve('err');
        });
    });
}
export const leadPutApi = (JsonObj,tag,email) => {
    return new Promise((resolve, reject) => {
        putContactLeadRegist(JsonObj,tag,email).then((res) => {
            resolve(res);
        }).catch((err) => {
            resolve('err');
        });
    });
}

export const GetResponse = (JsonObj, userData) => {
    return new Promise((resolve, reject) => {
        let currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const day = currentDate.getDate().toString().padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        // let aWithDates = JsonObj?.method !== "PUT" && JsonObj?.tag.map(item => `${item},${formattedDate}`);
        let aWithDates = JsonObj?.method !== "PUT" && JsonObj?.tag.map(item => `${item}`);

        getContactLead(JsonObj.email).then((res) => {
            let responseId = res?.data?.contacts[0]?.id;
            let deleteTag = JsonObj?.method !== "PUT" && res?.data?.contacts[0]?.tags.filter(itemA => {
                let partsA = itemA.replace(/\s/g, '').toLowerCase().split(',');
                let partialMatch = JsonObj?.method !== "PUT" && aWithDates.some(itemB => {
                    let partsB = itemB.replace(/\s/g, '').toLowerCase().split(',');
                    //  return partsA.slice(0, -1).join(',') == partsB.slice(0, -1).join(',');
                     return partsA.join(',') == partsB.join(',');

                });
                return partialMatch;
            });

            let json = {
                id: responseId,
                tags: aWithDates,
                deleteTagss: deleteTag,
                isContact: true
            }
            resolve(json);


        }).catch((err) => {
            resolve(err?.response?.data?.email?.message)
        })
    })
}
export const leadGetApi = async (JsonObj, json) => {

    const results = await GetResponse(JsonObj);

    if (results == null || results == undefined || results == "") {
        let currentDate = new Date()
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1; // Months are 0-based, so add 1
        const day = currentDate.getDate();
        const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
        // let aWithDates = JsonObj.tag.map(item => `${item},${formattedDate}`);
        let aWithDates = JsonObj.tag.map(item => `${item}`);
        const data = await leadPostContactApi(json, aWithDates);
        return data
    } else {
        return results
    }

}


export const getContactLead = async (email) => {

  return new Promise((resolve, reject) => {

    let url = `https://rest.gohighlevel.com/v1/contacts/lookup?email=${email}`;

    $CommonServiceFn.InvokeCommonApi2("GET",url,"",(response) => {
        if (response) {
          resolve(response);   // send response back to caller
        } else {
          reject("Something went wrong");
        }
      }
    );
  });
};



// export const  putContactLeadRegist = async (json, tag) => {
//         let cancel;
//         let url = 'https://rest.gohighlevel.com' + "/" + 'v1/contacts/' + json?.id
//         let body = {};
//         body['email'] = tag;
//         return $CommonServiceFn.InvokeCommonApi2(url, "PUT", body, cancel);
//     }

export const putContactLeadRegist = async (json, tag,email) => {

    let url = `https://rest.gohighlevel.com/v1/contacts/${json?.id}/tags/`;
    let body = {tags:tag};

    return new Promise((resolve, reject) => {
        $CommonServiceFn.InvokeCommonApi2("POST", url, body,(response) => {
                if (response) {
                    resolve(response);
                } else {
                    reject("Something went wrong");
                }
            }
        );
    });
};

export const deleteContactLead = async (json) => {

        let cancel;
        let url = 'https://rest.gohighlevel.com' + "/" + 'v1/contacts/' + json?.id + "/tags/"
        let body = {};
        body['tags'] = json.deleteTagss;
        return $CommonServiceFn.InvokeCommonApi2(url, "DELETE", body, cancel);
    }
export const  postContactLead =async (json) => {
        let cancel;
        let url = 'https://rest.gohighlevel.com' + "/" + 'v1/contacts/' + json?.id + "/tags/"
        let body = {};
        body['tags'] = json.tags;

        return $CommonServiceFn.InvokeCommonApi2(url, "POST", body, cancel);
    }


export const postContactLeadRegist = async (json, tag) => {
    let url = `https://rest.gohighlevel.com/v1/contacts/`;



      let body = {};
        body['email'] = json.emailAddress;
        body['phone'] = json.phoneNumber;
        body['firstName'] = json.firstName;
        body['lastName'] = json.lastName;
        body['tags'] = tag;



return new Promise((resolve, reject) => {
        $CommonServiceFn.InvokeCommonApi2("POST", url, body,(response) => {
                if (response) {
                    resolve(response);
                } else {
                    reject("Something went wrong");
                }
            }
        );
    });
};

export const getRoleIdOf = {
  "intakeMember": 1,
  "enquiryMember": 2,
  "paralegal": 3,
  "platformAdministrator": 4,
  "intakeAgent": 5,
  "eventCoordinator": 6,
  "speaker": 7,
  "planner": 8,
  "lpoLite": 9,
  "directIntakeMember": 10,
  "firmAdministrator": 11,
  "professionalUser": 12,
  "attorney": 13,
  "legalAssistant": 14,
  "lawOfficeStaff": 15,
  "eventCoordinatorMobile": 16,
  "aoAcademyUsers": 17,
  "aoAcademyUsers_18": 18,
  "surveyUser": 19,
  "legacyUser": 20,
  "notary": 22,
  "onDemandUser": 23
}
